import script from "./VToggleDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./VToggleDisplay.vue?vue&type=script&setup=true&lang=js"

import "./VToggleDisplay.vue?vue&type=style&index=0&id=7985bd8c&lang=scss&scoped=true"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7985bd8c"]])

export default __exports__